export const generateFileKey = (file: File): string => {
  const timestamp = Date.now();
  const randomString = Math.random().toString(36).substring(2, 15);
  const extension = file.name.split(".").pop();

  return `properties/${timestamp}-${randomString}.${extension}`;
};
